import React, { Component } from 'react'
import '../css/components/Chart.scss'
import Highcharts from 'highcharts/highstock'
import Spinner from './Spinner'
import classnames from 'classnames'
import { PUBLIC_FOLDER } from '../constants/urls'

interface ChartProps {
  series: any
  secondarySeries?: any
  id: string
  title: string
  settings: any
  multiSeries?: any
  error: boolean
}

class Chart extends Component<ChartProps> {
  componentDidMount() {
    Highcharts.setOptions({
      global: {
        // @ts-ignore
        useUTC: false,
      },
    })
    this.renderChart()
  }

  componentDidUpdate(prevProps: ChartProps) {
    if (this.mainDataHasChanged(prevProps) && this.secondaryDataHasChanged(prevProps)) {
      this.renderChart()
    }
  }

  mainDataHasChanged(prevProps: ChartProps) {
    const result = prevProps.series.data !== this.props.series.data
    return result
  }

  secondaryDataHasChanged(prevProps: ChartProps) {
    const prevSecondarySeries = prevProps.secondarySeries || {}
    const secondarySeries = this.props.secondarySeries || {}
    const result = !prevSecondarySeries.data || prevSecondarySeries.data !== secondarySeries.data
    return result
  }

  hasData = (series: any) => {
    return series.data && Object.keys(series.data).length > 0
  }

  renderChart() {
    // ToDo: Make sure this does not run unnecessarily
    const { id, title, settings, series, secondarySeries, multiSeries } = this.props

    let seriesList = [series]

    if (!seriesList.every(this.hasData)) return

    if (secondarySeries) {
      seriesList.push(secondarySeries)
    }
    if (multiSeries) {
      seriesList = [...seriesList, ...multiSeries]
    }

    const unit = settings.unit || ''
    const allowDecimals = settings.allowDecimals !== undefined ? settings.allowDecimals : true

    // @ts-ignore
    Highcharts.chart(id, {
      credits: {
        enabled: false,
      },
      chart: {
        zoomType: 'xy',
      },
      title: {
        text: title,
      },
      xAxis: {
        type: 'datetime',
        crosshair: true,
        plotLines: settings.xPlotLines || null,
      },
      yAxis: [
        {
          labels: {
            format: '{value}' + unit,
          },
          title: false,
          softMax: settings.softMax || null,
          softMin: settings.softMin || null,
          allowDecimals: allowDecimals,
          plotLines: settings.yPlotLines || null,
        },
      ],
      plotOptions: {
        series: {
          ...settings.series,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        scatter: {
          marker: {
            symbol: 'circle',
            radius: 1.5,
          },
        },
      },
      tooltip: {
        shared: true,
        valueSuffix: unit,
      },
      series: seriesList,
    })
  }

  getChartClassName() {
    return classnames('chart-element', {
      hide: !this.props.series.data || this.props.error,
    })
  }

  render() {
    const { series, error, title } = this.props
    return (
      <div className="chart">
        <div className={this.getChartClassName()} id={this.props.id} />
        {!series.data && !error && (
          <div className="loading">
            <Spinner size="20" />
          </div>
        )}
        {error && (
          <div className="error">
            <img
              className="error-icon"
              src={PUBLIC_FOLDER + '/icons/md_sentiment_very_dissatisfied_24px.svg'}
              alt="error"
            />
            <span className="error-text">Failed to retrieve {title}</span>
          </div>
        )}
      </div>
    )
  }
}

export default Chart
